if (!customElements.get('screenshot-guide')) {
  customElements.define('screenshot-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.links = [...this.querySelectorAll('[data-guide-link]')];
      this.targets = this.links.map(link => this.querySelector(link.hash)).filter(Boolean);
      this.links.forEach(link => link.addEventListener('click', event => {
        const target = this.querySelector(link.hash);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: this.motion(), block: 'start' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        history.replaceState(history.state, '', link.hash);
        this.setActive(target.id);
      }, options));
      this.querySelectorAll('[data-guide-tabs]').forEach(group => {
        const tabs = [...group.querySelectorAll('[data-guide-tab]')];
        const panels = [...group.querySelectorAll('[data-guide-panel]')];
        const select = index => {
          tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            panels[i].hidden = i !== index;
          });
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(index), options);
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            select(next);
            tabs[next].focus();
          }, options);
        });
        select(0);
      });
      this.querySelectorAll('[data-guide-carousel]').forEach(carousel => {
        const track = carousel.querySelector('[data-guide-track]');
        const prev = carousel.querySelector('[data-guide-prev]');
        const next = carousel.querySelector('[data-guide-next]');
        const position = carousel.querySelector('[data-guide-position]');
        const update = () => {
          const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= maximum - 2;
          const pages = Math.max(1, Math.ceil(track.scrollWidth / Math.max(track.clientWidth, 1)));
          const page = maximum > 0 && track.scrollLeft >= maximum - 2
            ? pages
            : Math.min(pages, Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) + 1);
          position.textContent = `${page} / ${pages}`;
        };
        prev.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: this.motion() }), options);
        next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: this.motion() }), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        window.addEventListener('resize', update, options);
        track.querySelectorAll('img').forEach(img => img.addEventListener('load', update, options));
        update();
      });
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateActive(); });
      };
      window.addEventListener('scroll', schedule, { ...options, passive: true });
      window.addEventListener('resize', schedule, options);
      this.addEventListener('shopify:block:select', event => event.target.closest('[data-guide-target]')?.scrollIntoView({ block: 'start', behavior: 'instant' }), options);
      this.updateActive();
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'; }
    updateActive() {
      if (!this.targets.length) return;
      const offset = (parseFloat(getComputedStyle(this).getPropertyValue('--guide-offset')) || 104) + 24;
      let current = this.targets[0];
      this.targets.forEach(target => { if (target.getBoundingClientRect().top <= offset) current = target; });
      this.setActive(current.id);
    }
    setActive(id) {
      this.links.forEach(link => {
        const active = link.hash === `#${id}`;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.controller = null;
    }
  });
}
